import { CartUpdateEvent } from '@theme/events';

class CompleteLookCard extends HTMLElement {
  connectedCallback() {
    try {
      this.variants = JSON.parse(this.querySelector('[data-look-variants]')?.textContent || '[]');
    } catch {
      this.variants = [];
    }

    this.selects = [...this.querySelectorAll('[data-look-select]')];
    this.button = this.querySelector('[data-look-add]');
    this.price = this.querySelector('[data-look-price]');
    this.image = this.querySelector('.em-look-list__image');

    this.selects.forEach((select) => select.addEventListener('change', this.onChange));
    this.button?.addEventListener('click', this.onAdd);

    this.update();
  }

  get selectedOptions() {
    return this.selects.map((select) => select.value);
  }

  get selectedVariant() {
    const selected = this.selectedOptions;
    return this.variants.find(
      (variant) =>
        variant.options.length === selected.length &&
        variant.options.every((value, index) => value === selected[index])
    );
  }

  onChange = () => {
    this.update();
  };

  update() {
    const selected = this.selectedOptions;

    this.selects.forEach((select, selectIndex) => {
      [...select.options].forEach((option) => {
        const possible = this.variants.some((variant) => {
          if (!variant.available) return false;

          return variant.options.every((value, optionIndex) => {
            if (optionIndex === selectIndex) return value === option.value;
            const chosen = selected[optionIndex];
            return !chosen || value === chosen;
          });
        });

        option.disabled = !possible;
      });
    });

    const variant = this.selectedVariant;

    if (this.button) {
      this.button.disabled = !variant?.available;
    }

    if (variant?.image && this.image) {
      this.image.src = variant.image;
      this.image.removeAttribute('srcset');
    }

    if (variant && this.price) {
      this.price.textContent = this.money(variant.price);
    }
  }

  money(cents) {
    const currency = window.Shopify?.currency?.active || 'TRY';

    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'tr-TR', {
        style: 'currency',
        currency,
      }).format(Number(cents || 0) / 100);
    } catch {
      return `${(Number(cents || 0) / 100).toFixed(2)} ${currency}`;
    }
  }

  onAdd = async () => {
    const variant = this.selectedVariant;
    if (!variant?.available || !this.button) return;

    const label = this.button.dataset.label || 'SEPETE EKLE';
    this.button.disabled = true;

    try {
      const root = window.Shopify?.routes?.root || '/';

      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        credentials: 'same-origin',
        body: JSON.stringify({
          items: [{ id: variant.id, quantity: 1 }],
        }),
      });

      if (!response.ok) {
        throw new Error(`Cart add failed: ${response.status}`);
      }

      await response.json();

      const cartResponse = await fetch(`${root}cart.js`, {
        headers: { Accept: 'application/json' },
        credentials: 'same-origin',
      });

      const cart = await cartResponse.json();

      document.dispatchEvent(
        new CartUpdateEvent(cart, this.dataset.productId || '', {
          source: 'ecomminds-complete-look',
          productId: this.dataset.productId || '',
          variantId: String(variant.id),
          itemCount: cart.item_count,
        })
      );

      this.button.textContent = 'EKLENDİ';

      window.setTimeout(() => {
        this.button.textContent = label;
        this.button.disabled = !this.selectedVariant?.available;
      }, 1200);
    } catch (error) {
      console.error('[EcomMinds Complete Look]', error);
      this.button.textContent = 'TEKRAR DENE';
      this.button.disabled = false;
    }
  };
}

if (!customElements.get('complete-look-card')) {
  customElements.define('complete-look-card', CompleteLookCard);
}
